/** Full-screen morphing-blob loader shown while the feed boots. */
export function Loader({ message = 'Loading ...' }) {
  return (
    <div class="loader">
      <div class="loader__blob" />
      <div class="loader__text">{message}</div>
    </div>
  );
}
